export default __webpack_public_path__ + "static/media/M1-male-01_mos_JLEE.df0d69cb.wav";